module.exports = __webpack_public_path__ + "img/lightning.62af9285.svg";